document.addEventListener('DOMContentLoaded', () => {
  const suggestedReadArticles = document.querySelectorAll('.ne-suggested-read-articles')

  if(suggestedReadArticles) {
    suggestedReadArticles.forEach(articles => {
      const innerArticles = articles.querySelectorAll('.pp-post-grid__item')
      let initialHeading = articles.querySelector('.wp-block-heading')
      
      if(innerArticles) {
        innerArticles.forEach(article => {
          const title = article.querySelector('.pp-post-grid__title')
      
          if(initialHeading && title) {
            let h2 = initialHeading.cloneNode(true)
            title.before(h2)
          } 
        })

        initialHeading.style.display = 'none'
      }

    })
  }

})